// extracted by mini-css-extract-plugin
module.exports = {"position_center":"Loader_position_center__EnUkZ","text":"Loader_text__afCuL"};